import React from 'react'

import heroImage from '../images/gain-hero.jpg'

function About() {
	return (
		<section className='about' id='quienes-somos' style={{ backgroundImage: `url(${heroImage})` }}>
			<div className='about__content'>
				<h2 className='about__title' data-aos='fade-right'>
					<span>¿Que es </span>
					<span>
						<strong>GAIN</strong>?
					</span>
				</h2>
				<div className='about__text' data-aos='fade-left'>
					<p>
						Somos un grupo de trabajo dedicado a la administración de inversiones. Buscamos hacerle
						más fácil la vida a nuestros clientes, ocupándonos de las distintas situaciones que
						surgen por el uso y realización de una inversión.
					</p>
					<p>
						En GAIN buscamos maximizar la renta siendo eficientes: facilitando pagos, cobros,
						refacciones y mantenimiento.
					</p>
				</div>
			</div>
		</section>
	)
}

export default About
